import { getRewardsRecentWinnersOptions } from '@/client/@tanstack/react-query.gen'
import { formatNumber } from '@/lib'
import { getParams } from '@/models/Config'
import { getConfig, getUserInfo, getWallet } from '@/models/User'
import { useStore } from '@/store'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useMemo, useState } from 'react'
import style from './Style.module.scss'

const NOTICE_INTERVAL = 3500 // ms giữa mỗi lần đổi thông báo

const Header = () => {
  const { updateState } = useStore()
  const userInfo = getUserInfo() ?? {}
  const wallet = getWallet() ?? {}
  const params = getParams()
  const config = getConfig()

  const { data: recentWinners } = useQuery(getRewardsRecentWinnersOptions())

  const itemNameById = useMemo(
    () => new Map(config?.items?.map((item) => [item.id, item.name])),
    [config?.items],
  )

  const milestoneNameById = useMemo(
    () =>
      new Map(
        config?.milestones?.map((milestone) => [milestone.id, milestone.name]),
      ),
    [config?.milestones],
  )

  const winners = useMemo(() => recentWinners?.winners ?? [], [recentWinners])

  const [activeIndex, setActiveIndex] = useState(0)

  useEffect(() => {
    setActiveIndex(0)
  }, [winners.length])

  useEffect(() => {
    if (winners.length <= 1) return undefined

    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % winners.length)
    }, NOTICE_INTERVAL)

    return () => clearInterval(timer)
  }, [winners.length])

  const currentWinner = winners[activeIndex]

  const noticeContent = useMemo(() => {
    if (!currentWinner) return undefined

    return {
      userName: currentWinner.userName,
      itemName: itemNameById.get(currentWinner.itemId) ?? 'phần thưởng',
      milestoneName: milestoneNameById.get(currentWinner.milestoneId) ?? 'hộp',
    }
  }, [currentWinner, itemNameById, milestoneNameById])

  return (
    <header className={style.header}>
      <div className={style.headerContainer}>
        <div className={style.siteTitle}>
          <div className={style.siteTitleImg}>
            <img src="/images/page-title.png" alt="title" />
            <div className={style.siteTitleText}>{params?.start_end}</div>
          </div>

          <div className={style.noticeTitleWrap}>
            {noticeContent && (
              <p key={activeIndex} className={style.noticeTitle}>
                Người chơi{' '}
                <span className={style.noticeUserName}>
                  {noticeContent.userName}
                </span>{' '}
                vừa nhận{' '}
                <span className={style.noticeItemName}>
                  {noticeContent.itemName}
                </span>{' '}
                từ{' '}
                <span className={style.noticeMilestoneName}>
                  {noticeContent.milestoneName}
                </span>
                !
              </p>
            )}
          </div>
        </div>

        <div className={style.loginArea}>
          {userInfo?.name && (
            <>
              <div className={style.loginText}>
                <a>{userInfo.name}</a>
                <br />

                <div className={style.gemBalance}>
                  <img src="/images/gem.png" alt="" />
                  {formatNumber(wallet.gems ?? 0)}
                </div>
              </div>

              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  updateState('modalRuleStatus', true)
                }}
                className={style.iconRule}
              >
                <img src="/images/icon-faq.png" alt="" />
              </a>

              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  updateState('modalHistoryStatus', true)
                }}
                className={style.iconHistory}
              >
                <img src="/images/icon-his.png" alt="" />
              </a>
            </>
          )}
        </div>
      </div>
    </header>
  )
}

export default Header
